import * as common from './common.json';

export const ru = {
  common,
};
